import React from 'react';

const ResourcesTab = () => {
  const resources = [
    {
      icon: '💳',
      title: 'What is Credit Utilization?',
      description: 'Learn how your credit card balances affect your score and why keeping utilization below 30% helps.',
      readTime: '3 min read'
    },
    {
      icon: '📊',
      title: 'Why Payment History Matters',
      description: 'Payment history is the biggest factor in your credit score. Understand how to maintain a perfect record.',
      readTime: '4 min read'
    },
    {
      icon: '🔍',
      title: 'Hard Inquiries Explained',
      description: 'What happens when you apply for new credit and how inquiries impact your score over time.',
      readTime: '3 min read'
    },
    {
      icon: '⏰',
      title: 'Best Time to Apply for Credit',
      description: 'Strategic timing for credit applications to minimize impact and maximize approval odds.',
      readTime: '5 min read'
    },
    {
      icon: '💡',
      title: 'Building Credit History',
      description: 'How to establish and maintain a strong credit history even with limited accounts.',
      readTime: '6 min read'
    },
    {
      icon: '🛡️',
      title: 'Protecting Your Credit',
      description: 'Best practices for monitoring your credit and preventing identity theft or fraud.',
      readTime: '4 min read'
    }
  ];

  return (
    <div className="tab-content">
      <div className="tab-header">
        <h2 className="tab-title">Credit Resources</h2>
        <p className="tab-subtitle">Learn how credit works and make informed decisions</p>
      </div>

      <div className="resources-grid">
        {resources.map((resource, index) => (
          <div 
            key={index} 
            className="resource-card"
            data-testid={`resource-card-${index}`}
          >
            <div className="resource-icon">{resource.icon}</div>
            <div className="resource-content">
              <h3 className="resource-title">{resource.title}</h3>
              <p className="resource-description">{resource.description}</p>
              <div className="resource-footer">
                <span className="read-time">{resource.readTime}</span>
                <button className="resource-btn" data-testid={`read-btn-${index}`}>
                  Read →
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="help-card">
        <div className="help-icon">💬</div>
        <div className="help-content">
          <h3 className="help-title">Need Help?</h3>
          <p className="help-text">
            Have questions about your credit plan or need personalized guidance?
          </p>
          <button className="help-btn" data-testid="contact-support-btn">
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResourcesTab;
